// import AddIcon from '@mui/icons-material/Add';
// import RemoveIcon from '@mui/icons-material/Remove';
// import React, { useEffect } from 'react';
// import { useState } from 'react';
// import { useSelector } from 'react-redux';

// const CounterApp = ({
//   index,
//   previousIndex,
//   setPreviousIndex,
//   currentIndex,
//   setCurrentIndex,
//   amount,
//   setAmount,
//   price,
// }) => {
//   const isActive = useSelector((state) => state.toggle.isActive);
//   const [count, setCount] = useState(1);

//   useEffect(() => {
//     if (currentIndex !== null) {
//       setPreviousIndex(currentIndex);
//     }
//   }, [currentIndex]);

//   const increment = (i) => {
//     setCurrentIndex(i); // currentIndex ko update karna

//     setCount(() => count + 1);
//     setAmount((count + 1) * price);
//   };

//   const decrement = (i) => {
//     if (currentIndex === index && count > 1) {
//       setCount((count) => count - 1);
//       setAmount((count - 1) * price);
//     }
//   };

//   return (
//     <div className="flex flex-row items-center">
//       <button
//         onClick={() => increment(index)}
//         className={`text-white h-full ${isActive ? 'rounded-r-full' : 'rounded-l-full'} py-2 px-2 bg-customgreen hover:bg-hovergreen transition duration-500 ease-in-out`}
//       >
//         <AddIcon color="white" />
//       </button>
//       <input
//         type="text"
//         value={previousIndex === index ? count : 1}
//         className="text-center bg-gray-200 w-full p-0 py-2 border-none no-focus-border focus:ring-0"
//         disabled
//       />
//       <button
//         onClick={() => decrement(index)}
//         className={`text-white h-full bg-customgreen py-2 ${isActive ? 'rounded-l-full' : 'rounded-r-full'} px-2 hover:bg-hovergreen transition duration-500 ease-in-out`}
//       >
//         <RemoveIcon />
//       </button>
//     </div>
//   );
// };

// export default CounterApp;

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const CounterApp = ({
  index,
  setPreviousIndex,
  currentIndex,
  setCurrentIndex,
  setAmount,
  price
}) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (currentIndex !== null) {
      setPreviousIndex(currentIndex);
    }
    // Reset count when switching to a different card
    if (currentIndex !== index) {
      setCount(0);
    }
  }, [currentIndex, index]);

  const increment = (i) => {
    setCurrentIndex(i);
    const newCount = count + 1;
    setCount(newCount);
    setAmount(newCount * price);
  };

  const decrement = (i) => {
    if (currentIndex === index && count > 0) {
      const newCount = count - 1;
      setCount(newCount);
      setAmount(newCount * price);
    }
  };

  return (
    <div className="flex flex-row items-center">
      <button
        onClick={() => increment(index)}
        className={`text-white h-full ${isActive ? 'rounded-r-full' : 'rounded-l-full'} py-2 px-2 bg-customgreen hover:bg-hovergreen transition duration-500 ease-in-out`}
      >
        <AddIcon color="white" />
      </button>
      <input
        type="text"
        value={currentIndex === index ? count : 0}
        className="text-center bg-gray-200 w-full p-0 py-2 border-none no-focus-border focus:ring-0"
        disabled
      />
      <button
        onClick={() => decrement(index)}
        className={`text-white h-full bg-customgreen py-2 ${isActive ? 'rounded-l-full' : 'rounded-r-full'} px-2 hover:bg-hovergreen transition duration-500 ease-in-out`}
      >
        <RemoveIcon />
      </button>
    </div>
  );
};

export default CounterApp;
